module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.1-rc.4-83.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.1-rc.4.md
// module id = 500
// module chunks = 344